import { useState, useEffect } from "react";
import { fetchTactics, createTactic, updateTactic, deleteTactic } from "../api/tactics";
import { serializeStatements } from "../components/tactic/tacticModel";
import { normalizeTactic as normalize } from "../utils/teamModel";

export function useTactics(teamId) {
  const [tactics, setTactics] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!teamId) return;
    let cancelled = false;
    setLoading(true);
    setError(null);
    fetchTactics()
      .then((data) => { if (!cancelled) setTactics(data.map(normalize)); })
      .catch((err) => { if (!cancelled) { console.error("Failed to load tactics:", err); setError(err.message); } })
      .finally(() => { if (!cancelled) setLoading(false); });
    return () => { cancelled = true; };
  }, [teamId]);

  const create = async (name) => {
    const created = await createTactic(name);
    const tactic = normalize(created);
    setTactics((prev) => [...prev, tactic]);
    return tactic;
  };

  const update = async (id, statements) => {
    await updateTactic(id, serializeStatements(statements));
    setTactics((prev) => prev.map((t) => (t.id === id ? { ...t, statements } : t)));
  };

  const remove = async (id) => {
    await deleteTactic(id);
    setTactics((prev) => prev.filter((t) => t.id !== id));
  };

  return { tactics, loading, error, create, update, remove };
}
